export default __webpack_public_path__ + "static/media/GoldFrame01.eb0636bc.png";